import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ethIcon from "./assets/ethh.PNG";
import usdtIcon from "./assets/usdt.png";
// Import createWeb3Modal with defaultConfig from @web3modal/ethers/react
import {
  createWeb3Modal,
  defaultConfig,
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers/react";
import {
  network,
  presaleAddress,
  presaleAbi,
  erc20Abi,
  tokenAddress,
  usdtAddresss,
  appKitProjectId,
  token,
} from "./utils/contants.js";
import "./App.css";
import { ethers, Contract } from "ethers";
import { Decimal } from "decimal.js";
import Swal from "sweetalert2";
import { formatNum } from "./utils/helper_utils.js";
import leftText from "./assets/texture-left.png";
import rightText from "./assets/texture-right.png";
import bottomleft from "./assets/karma.png";
import bottomright from "./assets/cloud.png";
const metadata = {
  name: "My Website",
  description: "My Website description",
  url: "https://mywebsite.com",
  icons: ["https://avatars.githubusercontent.com/u/37784886"],
};

createWeb3Modal({
  ethersConfig: defaultConfig({ metadata }),
  chains: [network],
  projectId: appKitProjectId,
  enableAnalytics: true,
  themeMode: "light",
});

const useSmallScreen = (maxWidth = 600) => {
  const query = `(max-width: ${maxWidth}px)`;
  const [isSmallScreen, setIsSmallScreen] = useState(
    window.matchMedia(query).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleResize = () => setIsSmallScreen(mediaQuery.matches);

    mediaQuery.addEventListener("change", handleResize);
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, [query]);

  return isSmallScreen;
};

const App = () => {
  const { t, i18n } = useTranslation();
  const { chainId, isConnected, address } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider();
  const [referralCode, setReferralCode] = useState("");
  const [ethValue, setEthValue] = useState("0.1");
  const [krmValue, setKrmValue] = useState("");
  const [selectedToken, setSelectedToken] = useState("ETH"); // "ETH" or "USDT"
  const [txPending, setTxPending] = useState(false);
  const isSmallScreen = useSmallScreen(600);
  const isMiniScreen = useSmallScreen(380);

  // Wallet & Contract states
  const [presaleContractNonSigner, setPresaleContractNonSigner] =
    useState(null);

  const [presaleContract, setPresaleContract] = useState(null);
  const [tokenContract, setTokenContract] = useState(null); // For KRM token (ERC20)
  const [usdtContract, setUsdtContract] = useState(null); // For USDT token (ERC20)

  // Presale details
  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());
  const [isSalePaused, setIsSalePaused] = useState(false);
  const [tokenPrice, setTokenPrice] = useState("0");
  const [totalTokensRaised, setTotalTokensRaised] = useState("0");
  const [userHoldings, setUserHoldings] = useState("0");
  const [provider, setProvider] = useState();

  // Countdown timer state
  const [timeLeft, setTimeLeft] = useState({
    days: "0",
    hours: "0",
    minutes: "0",
    seconds: "0",
  });
  const calculateTimeLeft = () => {
    const now = new Date();
    const difference =
      (Date.now() < startTime.getTime()
        ? startTime.getTime()
        : endTime.getTime()) - now.getTime();
    let timeLeftObj = { days: "0", hours: "0", minutes: "0", seconds: "0" };
    console.log(difference, startTime, endTime);
    if (difference > 0) {
      timeLeftObj = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)).toString(),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24).toString(),
        minutes: Math.floor((difference / (1000 * 60)) % 60).toString(),
        seconds: Math.floor((difference / 1000) % 60).toString(),
      };
    }
    return timeLeftObj;
  };

  const saleTimerText = useMemo(() => {
    if (isSalePaused || endTime.getTime() <= Date.now()) {
      return t("status.sale_ended");
    }
    if (startTime.getTime() > Date.now()) {
      return t("info.before_sale_start");
    }
    return t("info.sale_ends");
  }, [endTime, isSalePaused, startTime, t]);

  const isSaleActive = useMemo(() => {
    return (
      !isSalePaused &&
      startTime.getTime() <= Date.now() &&
      endTime.getTime() > Date.now()
    );
  }, [endTime, isSalePaused, startTime]);

  const init = async () => {
    try {
      if (!isConnected || !walletProvider) {
        setUserHoldings(0);
        setTokenPrice(0);
        setTotalTokensRaised(0);
        return;
      }
      const provider = new ethers.BrowserProvider(walletProvider);
      setProvider(provider);
      const signer = await provider.getSigner();
      const presaleContr = new Contract(presaleAddress, presaleAbi, signer);
      setPresaleContract(presaleContr);
      const tokenContr = new Contract(tokenAddress, erc20Abi, signer);
      setTokenContract(tokenContr);
      const usdtContr = new Contract(usdtAddresss, erc20Abi, signer);
      setUsdtContract(usdtContr);
      fetchPresaleDetails(presaleContr);
      fetchUserHoldings(tokenContr, address);
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: t("errors.error"),
        text: t("errors.failed_to_load_contract"),
        icon: "error",
      });
    }
  };

  const fetchPresaleDetails = async (contract) => {
    try {
      if (!contract) return;
      const _startTime = await contract.startTime();
      setStartTime(new Date(Number(_startTime) * 1000));

      const _endTime = await contract.endTime();
      setEndTime(new Date(Number(_endTime) * 1000));

      console.log("end time here", endTime);
      const _paused = await contract.paused();
      setIsSalePaused(_paused);
      const _price = await contract.price();
      setTokenPrice(new Decimal(_price.toString()).div(1e8).toFixed(4));
      const _totalSold = await contract.totalTokensSold();
      setTotalTokensRaised(ethers.formatUnits(_totalSold, 18));
    } catch (error) {
      console.error("Error fetching presale details:", error);
    }
  };

  const fetchUserHoldings = async (tokenContr, addr) => {
    try {
      if (!tokenContr || !addr) return;
      const balance = await tokenContr.balanceOf(addr);
      setUserHoldings(ethers.formatUnits(balance, 18));
    } catch (error) {
      console.error("Error fetching user holdings:", error);
    }
  };

  const syncTokenReceivable = async () => {
    try {
      if (!presaleContractNonSigner) return;
      if (selectedToken === "ETH") {
        const bigValue = ethers.parseUnits(ethValue, 18);
        const tokens = await presaleContractNonSigner.nativeBuyHelper(bigValue);
        setKrmValue(ethers.formatUnits(tokens, 18));
      } else {
        /* eslint-disable no-undef */
        const bigValue = ethers.parseUnits(ethValue, 6);
        const tokens = await presaleContractNonSigner.calculateToken(
          bigValue * BigInt("1000000000000")
        );
        console.log(tokens);
        setKrmValue(ethers.formatUnits(tokens, 18));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleInputChange = async (value) => {
    setEthValue(value);
  };

  const getSaleStatusText = () => {
    if (isSalePaused || endTime.getTime() <= Date.now()) {
      return t("status.sale_ended");
    }
    if (startTime.getTime() > Date.now()) {
      return t("status.sale_in_future");
    }
    return "";
  };

  useEffect(() => {
    syncTokenReceivable();
  }, [ethValue, presaleContractNonSigner]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [startTime, endTime]);

  const addToken = async () => {
    if (!walletProvider) {
      Swal.fire(t("errors.connect_wallet_error"), "", "warning");
      return;
    }
    try {
      await walletProvider.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20", // The standard of the token (ERC20)
          options: {
            address: tokenAddress, // The contract address of the token
            symbol: token.symbol, // The symbol of the token
            decimals: token.decimals, // The number of decimals of the token
            image: token.image, // The image of the token
          },
        },
      });
      Swal.fire(t("info.token_imported"), "", "success");
    } catch (error) {
      Swal.fire(
        t("info.wallet_not_supported"),
        t("info.import_token_manually"),
        "warning"
      );
      console.log(error);
    }
  };

  const buyTokens = async (e) => {
    e.preventDefault();
    if (!presaleContract || !isConnected) {
      Swal.fire({
        title: t("errors.error"),
        text: t("errors.connect_wallet_error"),
        icon: "error",
      });
      return;
    }
    if (ethValue === "") {
      Swal.fire({
        title: t("errors.error"),
        text: t("errors.zero_error"),
        icon: "error",
      });
      return;
    }
    try {
      setTxPending(true);
      if (referralCode.trim() !== "") {
        const affiliateData = await presaleContract.affiliateMap(referralCode);
        if (affiliateData.user === ethers.ZeroAddress) {
          setTxPending(false);
          Swal.fire({
            title: t("errors.error"),
            text: t("errors.referal_not_found"),
            icon: "error",
          });
          return;
        }
      }
      if (selectedToken === "ETH") {
        const valueToSend = ethers.parseUnits(ethValue, 18);
        const tx = await presaleContract.buyWithNative(referralCode, {
          value: valueToSend,
        });
        await tx.wait();
        Swal.fire({
          title: t("success.success"),
          text: t("success.purchase_with_eth"),
          icon: "success",
          confirmButtonText: "Ok",
        });
      } else {
        const valueToSend = ethers.parseUnits(ethValue, 6);
        if (!usdtContract) {
          Swal.fire({
            title: t("errors.error"),
            text: t("errors.USDT_not_initialized"),
            icon: "error",
          });
          setTxPending(false);
          return;
        }
        const txApprove1 = await usdtContract.approve(
          presaleAddress,
          valueToSend
        );
        await txApprove1.wait();
        const tx = await presaleContract.buyWithUSDT(valueToSend, referralCode);
        await tx.wait();
        Swal.fire({
          title: t("success.success"),
          text: t("success.purchase_with_usdt"),
          icon: "success",
          confirmButtonText: "Ok",
        });
      }
      setEthValue("");
      setKrmValue("");
      if (tokenContract && address) {
        fetchUserHoldings(tokenContract, address);
      }
      fetchPresaleDetails();
    } catch (error) {
      console.error("Buy tokens error:", error);
      Swal.fire({
        title: t("errors.error"),
        text: t("errors.transaction_failed"),
        icon: "error",
      });
    } finally {
      setTxPending(false);
    }
  };

  useEffect(() => {
    if (chainId !== network.chainId && isConnected) {
      Swal.fire({
        title: t("errors.error"),
        text: t("errors.invalid_chainid"),
        icon: "error",
      });
    } else {
      init();
    }
  }, [walletProvider, isConnected, chainId]);

  const intialize = async () => {
    try {
      const provider = new ethers.JsonRpcProvider(network.rpcUrl);
      const _presaleContract = new Contract(
        presaleAddress,
        presaleAbi,
        provider
      );
      setPresaleContractNonSigner(_presaleContract);
      fetchPresaleDetails(_presaleContract);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    intialize();
  }, []);

  return (
    <div className="container">
      <div className="wrapper">
        <div className="timer-wrap">
          <div>
            <h1>{timeLeft.days}</h1>
            <span>Days</span>
          </div>
          <div>
            <h1>{timeLeft.hours}</h1>
            <span>Hours</span>
          </div>
          <div>
            <h1>{timeLeft.minutes}</h1>
            <span>Mins</span>
          </div>
          <div>
            <h1>{timeLeft.seconds}</h1>
            <span>Secs</span>
          </div>
        </div>

        <div className="positions">
          <div className="left-texture">
            <img src={leftText} alt="left" />
          </div>
          <div className="right-texture">
            <img src={rightText} alt="left" />
          </div>

          <div className="bottom-left">
            <img src={bottomleft} alt="krm" />
          </div>
          <div className="bottom-right">
            <img src={bottomright} alt="cloud" />
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "6px",
            fontSize: "20px",
            fontWeight: "bold",
            marginBottom: "0px",
            color: "#53b8d5",
          }}
        >
          {saleTimerText}
        </div>

        {/* <div
          className="price"
          style={{
            position: "fixed",
            margin: "0px",
            left: isMiniScreen ? "82%" : "320px",
            right: isMiniScreen ? "180px" : isSmallScreen ? "90px" : "0px",
            top: isMiniScreen ? "70px" : isSmallScreen ? "90px" : "100px",
            scale: isMiniScreen ? "0.6" : isSmallScreen ? "0.65" : "1",
          }}
        >
          {isConnected && (
            <w3m-button balance="hide" label={t("users.connect_wallet")} />
          )}
        </div> */}

        <div className="price" style={{ margin: "4px 0px" }}>
          <h4>1 KRM</h4>
          <h4>=</h4>
          <h4>{tokenPrice}$</h4>
        </div>

        <div className="tokens">
          <div>
            <h4>{t("users.token_raised")}:</h4>
            <h4>{formatNum(totalTokensRaised, 2)} KRM</h4>
          </div>
          <div>
            <h4>{t("users.your_holdings")}:</h4>
            <span>{formatNum(userHoldings, 2)} KRM</span>
          </div>
          <div>
            <div
              style={{
                scale: "0.9",
                position: "relative",
                right: isConnected ? "15px" : "7px",
              }}
            >
              {isConnected && (
                <w3m-button balance="hide" label={t("users.connect_wallet")} />
              )}
            </div>
            <div className="import" style={{ marginTop: "0px" }}>
              {/* <p>{t("users.import_token")}</p> */}
              <button
                style={{ marginTop: "0px" }}
                autoCapitalize="on"
                disabled={!isConnected}
                onClick={addToken}
              >
                + {t("users.add_token")}
              </button>
            </div>
          </div>
        </div>

        <div className="divider"></div>

        <div className="buy-with">
          <p>{t("users.buy_with_one")}:</p>
          <div>
            <button
              type="button"
              onClick={() => {
                setSelectedToken("ETH");
                setEthValue("");
                setKrmValue("");
              }}
              className={selectedToken === "ETH" ? "active" : ""}
            >
              <img src={ethIcon} alt="ETH" /> <span>ETH</span>
            </button>
            <button
              type="button"
              onClick={() => {
                setSelectedToken("USDT");
                setEthValue("");
                setKrmValue("");
              }}
              className={selectedToken === "USDT" ? "active" : ""}
            >
              <img src={usdtIcon} alt="USDT" /> <span>USDT</span>
            </button>
          </div>
        </div>

        <form onSubmit={buyTokens}>
          <div>
            <label htmlFor="referral">{t("users.referal_code")}</label> <br />
            <input
              type="text"
              name="referral"
              id="referral"
              placeholder="Enter Referral code"
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="ethValue">
              {selectedToken} {t("users.you_pay")}
            </label>{" "}
            <br />
            <div className="ethupay">
              <input
                type="text"
                name="ethValue"
                id="ethValue"
                value={ethValue}
                onChange={(e) => handleInputChange(e.target.value)}
              />
              <button
                type="button"
                disabled={!isConnected}
                onClick={async () => {
                  try {
                    if (selectedToken === "ETH") {
                      // For ETH, fetch the native balance from the provider
                      const balBN = await provider.getBalance(address);
                      const balStr = ethers.formatUnits(balBN, 18);
                      setEthValue(balStr);
                      handleInputChange(balStr);
                    } else {
                      // For USDT, fetch the USDT balance from the USDT contract
                      const balBN = await usdtContract.balanceOf(address);
                      const balStr = ethers.formatUnits(balBN, 6);
                      setEthValue(balStr);
                      handleInputChange(balStr);
                    }
                  } catch (error) {
                    Swal.fire({
                      title: t("errors.error"),
                      text: t("errors.failed_to_fetch_balance"),
                      icon: "error",
                    });
                  }
                }}
              >
                Max
              </button>
              <img src={selectedToken === "ETH" ? ethIcon : usdtIcon} alt="" />
            </div>
          </div>
          <div>
            <label htmlFor="krm">KRM {t("users.you_receive")}</label> <br />
            <input
              type="text"
              name="krm"
              id="krm"
              value={formatNum(krmValue, 2)}
              readOnly
            />
          </div>
          <div className="connect">
            {!isConnected ? (
              <w3m-button balance="hide" label={t("users.connect_wallet")} />
            ) : txPending ? (
              <button type="button" disabled>
                {t("users.buying")}...
              </button>
            ) : !isSaleActive ? (
              <button type="submit" disabled={true}>
                {getSaleStatusText()}
              </button>
            ) : (
              <button type="submit">
                {t("users.buy_with")} {selectedToken === "ETH" ? "ETH" : "USDT"}
              </button>
            )}
          </div>
          {/* <div className="d-flex">
            {isConnected && (
              <w3m-button balance="hide" label={t("users.connect_wallet")} />
            )}
          </div> */}
          <div
            style={{
              color: "white",
              display: "flex",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            {t("users.import_token")}
          </div>
        </form>
      </div>
    </div>
  );
};

export default App;
